import React from "react";
import Step3Terminal from "./Step3Terminal";

const DRAFT_KEY = "onboarding_draft";
const loadStepData = (stepIndex) => {
    try {
        const raw = window.localStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        return data.allFormData ? data.allFormData[stepIndex] : null;
    } catch {
        return null;
    }
};

const EditStep3Terminal = ({
    onNext,
    onBack,
    isSubmitting,
    onboardingAppId,
    business_entity_id,
    readOnly,
    onSkip,
    onGenerateMaf,
    mafLoading,
    // These are now passed from EditOnboardingApplication
    merchantData,
    formData,
}) => {
    const resolvedMerchantData = merchantData || loadStepData(1);
    const resolvedFormData = formData || loadStepData(2);

    return (
        <Step3Terminal
            formData={resolvedFormData}
            merchantData={resolvedMerchantData}
            onNext={onNext}
            onBack={onBack}
            isSubmitting={isSubmitting}
            readOnly={readOnly}
            onSkip={onSkip}
        />
    );
};

export default EditStep3Terminal;
